import './FirstDayOverlayContent.styl';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useStoreContext } from 'store/app';
import { useTranslationsContext } from 'store/translations';
import { StorageKeys } from 'utils/storageKeys';

export const FirstDayOverlayContent = observer(() => {
    const { translate } = useTranslationsContext();
    const { setUserVariable } = useStoreContext();

    useEffect(() => {
        setUserVariable(StorageKeys.VISITED, 'true');
    }, []);

    return (
        <div className="first-day-overlay">
            <div className="first-day-overlay-title">{translate('first.day.overlay')}</div>
        </div>
    );
});
